import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function Delivered(props) {
  if (props.status === "Delivery") {
    return (
      <Svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Circle cx="4" cy="4" r="4" fill="#00AB59" />
      </Svg>
    );
  }
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M10 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zM7.832 13.432L4.96 10.56a.797.797 0 111.128-1.128L8.4 11.736l5.504-5.504a.797.797 0 111.128 1.128L8.96 13.432a.797.797 0 01-1.128 0z"
        fill="#27AE60"
      />
    </Svg>
  );
}

export default Delivered;
